import { ROTA_APIS } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";

AxiosCurlirize(axios, () => {});

export interface IDeactivateBookingFeeConfigResponse {
  status: boolean;
  message: string;
  data?: { modified_count?: number };
}

export const useDeactivateBookingFeeConfigAPI = () => {
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const configuration = useConfiguration();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const execute = useCallback(
    async (configurationIds: string[]) => {
      setIsLoading(true);
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response = await axios
          .post(
            `${ROTA_APIS?.ROTA_BOOKING_FEE_CONFIG_DEACTIVATE?.baseURL}`,
            { configuration_ids: configurationIds },
            {
              headers: {
                Authorization: `${accessToken}`,
                "Content-Type": "application/json",
              },
            },
          )
          .then((res: AxiosResponse<IDeactivateBookingFeeConfigResponse>) => {
            if (res.data.status === true) {
              toast.success(res.data.message || "Configurations marked inactive.");
              return { status: true, message: res.data.message };
            } else {
              toast.error(res.data.message || "Failed to mark configurations inactive.");
              return { status: false, message: res.data.message };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            toast.error("Error marking configurations inactive.");
            return { status: false, message: "Error marking configurations inactive." };
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
        return { status: false, message: e.message };
      } finally {
        setIsLoading(false);
      }
    },
    [configuration, sendCurl, captureError],
  );

  return { execute, isLoading };
};
